import script from "./MazdaJsonRedisPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MazdaJsonRedisPanel.vue?vue&type=script&setup=true&lang=js"

import "./MazdaJsonRedisPanel.vue?vue&type=style&index=0&id=c1a2f95e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1a2f95e"]])

export default __exports__